import TermsAndConditionsView from "./TermsAndConditionsView";
export default TermsAndConditionsView;